/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * showcan API
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetSessionResponse,
  OpenaiRealtimeApiParams,
  SessionBody,
} from "../../model";

import { customClient } from "../../custom-client";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get ephemeral key for OpenAI Realtime API WebRTC session
 * @summary Get OpenAI Realtime API session
 */
export const getOpenaiRealtimeApiUrl = (
  tenantId: string,
  params?: OpenaiRealtimeApiParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/public/realtime/session/${tenantId}?${stringifiedParams}`
    : `/api/v1/public/realtime/session/${tenantId}`;
};

export const openaiRealtimeApi = async (
  tenantId: string,
  sessionBody: NonReadonly<SessionBody>,
  params?: OpenaiRealtimeApiParams,
  options?: RequestInit,
): Promise<GetSessionResponse> => {
  return customClient<GetSessionResponse>(
    getOpenaiRealtimeApiUrl(tenantId, params),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sessionBody),
    },
  );
};
